import { memo } from 'react';
import { TextMessageBubble } from 'components/Dialogue';
import EnhanceText from 'components/Dialogue/components/Message/EnhanceText';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { getMetaFromSender } from '../../utils';
import { BaseMsgProps } from './types';

export const JolectFixedReplyMsg = memo((props: BaseMsgProps) => {
  const { msg, raw } = props;
  const text = raw.jlFixedReplyContent?.text;

  if (!text) {
    return null;
  }

  const { layout, color } = getMetaFromSender(msg.sender);

  return (
    <MessageExtendComplex
      {...props}
      showSourceContent={false}
      content={
        <TextMessageBubble color={color} className={layout}>
          <EnhanceText text={text} platform={raw.channel} />
        </TextMessageBubble>
      }
    />
  );
});
